import * as CONST from "../const/action.const";
import { removeObjectWithId } from "../helpers/utils";

const initialState = {
  students_list: [],
  students_from_request: [],
  new_student: null,
  info_student: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CONST.CREATE_PARENTAL_INFO_SUCCESS:
      return {
        ...state,
        new_student: payload,
        students_list:
          payload.students.length > 0 //check if the payload have kids to add them to the list
            ? state.students_list.concat(payload.students)
            : state.students_list.concat(payload),
        students_from_request: [],
      };
    case CONST.CREATE_PARENTAL_INFO_FAILURE:
      return {
        ...state,
        new_student: null,
      };
    case CONST.GET_STUDENTS_LIST_SUCCESS:
      return {
        ...state,
        students_list: payload.reverse(),
      };
    case CONST.GET_STUDENTS_LIST_FAILURE:
      return {
        ...state,
        students_list: null,
      };
    case CONST.CREATE_STUDENT_PERSONAL_MANUALLY_SUCCESS:
      return {
        ...state,
        new_student: payload,
        students_list:
          payload?.students?.length > 0 //check if the payload have kids to add them to the list
            ? state.students_list.concat(payload.students)
            : state.students_list.concat(payload),
        students_from_request: [],
      };
    case CONST.CREATE_STUDENT_PERSONAL_MANUALLY_FAILURE:
      return {
        ...state,
        new_student: null,
      };
    case CONST.FIND_STUDENT_INFO_SUCCESS:
      console.log("paaaaaaaaaaaaaaaaaaaayload",payload)
      return {
        ...state,
        info_student: payload,
      };
    case CONST.FIND_STUDENT_INFO_FAILURE:
      return {
        ...state,
        info_student: null,
      };
    case CONST.UPDATE_STUDENT_INFO_SUCCESS:
      return {
        ...state,
        info_student: payload,
        
      };
    case CONST.UPDATE_STUDENT_INFO_FAILURE:
      return {
        ...state,
        info_student: payload,
      };
    case CONST.DELETE_STUDENT_SUCCESS:
      const new_students_list=removeObjectWithId(state.students_list,payload)
      return {
        ...state,
        students_list: new_students_list,
      };
    case CONST.DELETE_STUDENT_FAILURE:
      return {
        ...state,
        students_list: state.students_list,
      };
    default:
      return state;
  }
}
